export const isRegex = (value: unknown): value is RegExp => value instanceof RegExp;
